import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

import descriptionStyle from "assets/jss/material-kit-pro-react/views/aboutUsSections/descriptionStyle.jsx";

function SectionDescription(props) {
  const { classes } = props;
  return (
    <div className={classNames(classes.aboutDescription)}>
      <GridContainer>
        <GridItem
          md={8}
          sm={8}
          className={classNames(classes.mrAuto, classes.mlAuto)}
        >
          <h2 className={classes.description, classes.textCenter}>
            ANALYZING TRENDS PROVIDES BENEFITS THAT ALLOW APPROPRIATE DECISION-MAKING
          </h2>
          <h3>BETTER INSIGHTS. BETTER INVESTMENTS</h3>
          <h5>Kinos provide business intelligence solutions to an entire spectrum of clients.
             Be they Banks, Housing Finance Company, Developers, Funds, Mortgage Insurance Companies, or Suppliers,
              the research helps them identify the opportunities as well as gauge the associated risks, in the market.

          </h5>

          <h5>
          Market Intelligence Is Vital In Making The Best Decisions For Your Business
          Cutting-edge technology and dedicated people
          It‘s the combination that gives you the most comprehensive, in-depth and accurate data out there.

          </h5>

        </GridItem>
      </GridContainer>
    </div>
  );
}

export default withStyles(descriptionStyle)(SectionDescription);
